import React from 'react';
import SpeakerHeadshot from '../ui-components/SpeakerHeadshot';
import { getFormattedSpeakerName } from '../utils/helpers.js';

const SpeakerCard = ({ speaker, onClick, visibleSpeakerFields = [] }) => {
  return (
    <div className="speaker-card" onClick={onClick} style={{ cursor: 'pointer' }}>
      <div className="speaker-card__image">
        <SpeakerHeadshot speaker={speaker} height={270} width={270} />
      </div>
      <div className="speaker-card__content">
        <h3 className="speaker-card__name">
          {getFormattedSpeakerName(
            visibleSpeakerFields.includes('salutation') ? speaker.salutation : '',
            speaker.full_name,
            visibleSpeakerFields.includes('honorific') ? speaker.honorific : ''
          )}
        </h3>
        <div className="speaker-card__details">
          <p className="speaker-card__job-title">{speaker.title}</p>
          <p className="speaker-card__company">{speaker.company_name}</p>
        </div>
      </div>
    </div>
  );
};

export default SpeakerCard;
